var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "table",
    { staticClass: "table is-narrow is-fullwidth is-marginless" },
    [
      _c("tbody", [
        _c("tr", [
          _c("th", [_vm._v("Ruta")]),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(_vm.unidadCompuesta.ruta))]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [_vm._v("Fecha creación")]),
          _vm._v(" "),
          _c("td", [
            _vm._v(
              _vm._s(
                _vm._f("moment")(
                  new Date(_vm.unidadCompuesta.created_at),
                  "dddd, DD/MM/YYYY, HH:mm:ss"
                )
              )
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }